// extracted by mini-css-extract-plugin
export var externalLink = "_9r-0";
export var internalLinkLabel = "_9r-1";